// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gaGlo","iconCircle":"styles_iconCircle__ZXT_C"};